import { render, staticRenderFns } from "./DeliveryInstructionItem.vue?vue&type=template&id=0fdafe3a&"
import script from "./DeliveryInstructionItem.vue?vue&type=script&lang=js&"
export * from "./DeliveryInstructionItem.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInstructionItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports